import { setDeleteArray } from "../../features/genericCommentsAndFilesSlice";
import { setAllUsers, setDisplayErrorSnackBar } from "../../features/userSlice";
import { discussionCommentsFilesService } from "../../services/api/discussion-comments-files.endpoints";
import store from "../../store";

// get all users(For mention feature in comments)
async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await discussionCommentsFilesService.getAllUsers(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// get all comments
async function getListOfComments(
  oauthTokenHeader: any,
  object_type: string,
  object_shared_uid: any,
  setComments: any,
  last_time?: any
) {
  try {
    const response = await discussionCommentsFilesService.getComments(
      oauthTokenHeader,
      object_type,
      object_shared_uid,
      last_time
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get comments.");
    } else if (response.status === 200) {
      const rawData = response?.data?.data ?? {}; // fallback to empty object
      const updatedComments: any[] = [];
      const deletedComments: any[] = [];

      Object.values(rawData).forEach((entry: any) => {
        if (entry?.updated && Array.isArray(entry.updated)) {
          updatedComments.push(...entry.updated);
        }
        if (entry?.deleted && Array.isArray(entry.deleted)) {
          deletedComments.push(...entry.deleted);
        }
      });
      setComments(updatedComments);
      store.dispatch(setDeleteArray(deletedComments));
    }
  } catch (e: any) {
    console.error(e);
  }
}

//add new comment
async function addNewComment(
  oauthTokenHeader: any,
  data: any,
  objectSharedUid: any
) {
  try {
    const response = await discussionCommentsFilesService.postComment(
      oauthTokenHeader,
      data,
      objectSharedUid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to add comment");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// edit single comment
async function updateSingleComment(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await discussionCommentsFilesService.putComments(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comment.");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// delete single comment
async function deleteSingleComment(
  oauthTokenHeader: any,
  object_shared_uid: any,
  comment_shared_uid: any
) {
  try {
    const response = await discussionCommentsFilesService.deleteComment(
      oauthTokenHeader,
      object_shared_uid,
      comment_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comment.");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// get all files
async function getListOfFiles(
  oauthTokenHeader: any,
  object_type: string,
  object_shared_uid: any,
  setFiles: any
) {
  try {
    const response = await discussionCommentsFilesService.getFiles(
      oauthTokenHeader,
      object_type,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setFiles([]);
      throw new Error("Failed to get files");
    } else {
      const rawData = response?.data?.data ?? {}; // fallback to empty object
      const filterCommentData =
        Object.values(rawData).filter(
          (arr) => Array.isArray(arr) && arr.length > 0
        ) || [];
      setFiles(filterCommentData?.flat());
    }
  } catch (e: any) {
    console.error(e);
  }
}

// Add new file
async function addNewFile(
  oauthTokenHeader: any,
  data: any,
  object_shared_uid: any
) {
  try {
    const response = await discussionCommentsFilesService.uploadFile(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

// delete single file
async function deleteSingleFile(oauthTokenHeader: any, file_shared_uid: any) {
  try {
    const response = await discussionCommentsFilesService.deleteFile(
      oauthTokenHeader,
      file_shared_uid
    );
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
      // according to the API documentation, it returns 204 for successful deletion
    } else if (response.status === 204) {
      //response?.data as returns null when file is deleted successfully
      // This is a success case, so we can return a custom success message
      // let sucessMsg = { reason: "Success." }; // Set a success message
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

export const DiscussionCommentsAndFilesEndPointLogic = {
  getAllUserList,
  addNewComment,
  getListOfComments,
  updateSingleComment,
  deleteSingleComment,
  getListOfFiles,
  addNewFile,
  deleteSingleFile,
};
